<template>
	<v-card>
			<v-container>
				<v-toolbar-title class="mb-4">Geral</v-toolbar-title>
				<div class="subtitle-1"> Primária </div>
				<v-row>
					<v-col cols="12" sm="6">
						<v-select
							label="Tipo Sanguineo"
							v-model="value.tipoSanguineo"
							:items="tiposSanguineos"
							clearable
						/>
					</v-col>
					<v-col cols="12" sm="6">
						<v-text-field
							label="Profissão"
							v-model="value.profissao"
						/>
					</v-col>
					<v-col cols="12" sm="6">
						<v-text-field
							label="Cargo"
							v-model="value.cargo"
						/>
					</v-col>
					<v-col cols="12" sm="6">
						<v-text-field
							label="Empresa"
							v-model="value.empresa"
						/>
					</v-col>
					<v-col cols="12">
						<v-text-field
							label="Profissões / Hobbie"
							v-model="value.hobbie"
						/>
					</v-col>
				</v-row>
			</v-container>
		</v-card>
</template>

<script setup lang="ts">
import { tiposSanguineos } from '../../../shareds/sharedsIrmao'
import { defineComponent, ref } from 'vue'
import { InputIrmao } from 'common/types/Irmao'

defineComponent({
	inheritAttrs: true,
})

defineProps<{
	value: InputIrmao
}>()

const emit = defineEmits(['update:modelValue']);
</script>